import React from 'react'

import { Helmet } from 'react-helmet'
import { Alert, Button, Row, Col } from 'react-bootstrap'

const Help = () => {
  return (
    <>
      <Helmet>
        <title>Help</title>
      </Helmet>
      <Row>
        <Col>
          <h1>Help</h1>
          <p className="lead">
            Whether you want to know more about the linking process or have
            technical questions, we&apos;re here to help. We{' '}
            <span role="img" aria-label="love">
              ❤️
            </span>{' '}
            feedback, too so let us know your thoughts.
          </p>
          <Alert variant="info" dismissible={false}>
            <strong>Experiencing technical difficulties?</strong> Take a note of
            the URL that you were on and what you were trying to do. Screenshots
            are also a great help so we can investigate any issues.
          </Alert>
          <p className="mb-3">
            <Button
              variant="primary"
              className="text-wrap"
              as="a"
              href="https://www.jcu.edu.au/helpdesk"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact the IT Help Desk
            </Button>
          </p>

          <h3>Known issues</h3>
          <ul>
            <li>
              If you have trouble logging into ORCID or linking your ORCID iD,
              then close all browser tabs or windows related to{' '}
              <a href="https://orcid.org">orcid.org</a> and clear your cookies.
              Alternatively, start a fresh browser session and try again.
            </li>
          </ul>
        </Col>
      </Row>
    </>
  )
}

export default Help
